export default __webpack_public_path__ + "static/media/025-detective.75797143.svg";